import { Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const ADMIN_MEASURE = 560;
export const ADMIN_ROW_MIN_HEIGHT = 52;
// The admin card corner radius. Shared so a card and anything that has to
// re-create its corners (e.g. a sticky table header pinned over a clip:false
// card) stay locked to one value.
export const ADMIN_CARD_RADIUS = 16;
export const MONO_FONT = "SF Mono, ui-monospace, Menlo, Consolas, monospace";

export const ADMIN_TOOLBAR_PAD = "16px 40px 12px";
export const ADMIN_CONTENT_PAD = "8px 40px 72px";

export type Tone = "on" | "attention" | "off" | "demo";

export function adminToneColor(theme: Theme, tone: Tone): string {
  const { palette } = theme;
  switch (tone) {
    case "on":
      return palette.success.dark;
    case "attention":
      return palette.warning.light;
    case "demo":
      return palette.secondary.main;
    case "off":
    default:
      return palette.grey[500];
  }
}

export const FOCUS_GLOW = (theme: Theme): string =>
  `${alpha(theme.palette.secondary.main, 0.1)} 0 0 0 0.2rem`;

export const focusRing = (theme: Theme) => ({
  "&.Mui-focusVisible": {
    boxShadow: FOCUS_GLOW(theme),
  },
});
